import {css} from '@emotion/core'
import styled from '@emotion/styled'
import {
  backgroundGray, black, lightBlue,
  marketingMobileCuttoff,
} from "@css/constants";
import {fontSize} from "@css/styles";
import {FontNormal} from "@css/fonts";
import {Button} from "@components/Button";

export type EarnPointsImageProps = {
  imageUrl: string
}

export type DotProps = {
  color: string
}

export const EarnPointsSectionContainer = styled('div')(css`
  display: flex;
  flex-direction: column;
  padding-top: 60px;
  background-color: ${backgroundGray};
  align-items: center;

  @media(max-width: ${marketingMobileCuttoff}) {
    flex-direction: column;
  }
`)

export const EarnPointsSectionRow = styled('div')(css`
  display: flex;
  flex-direction: row;
  align-self: center;
  place-content: center;
  margin-bottom: 32px;
  width: 85%;
  max-width: 914px;
  
  @media(max-width: ${marketingMobileCuttoff}) {
    flex-direction: column;
    display: block;
    margin-bottom: 0;
  }
`)

export const EarnPointsSectionRowMobile = styled(EarnPointsSectionRow)`

  @media(max-width: ${marketingMobileCuttoff}) {
    display: none;
  }
`;

export const QuizCard = styled('div')(css`
  display: flex;
  width: 100%;
  flex-direction: column;

  @media(max-width: ${marketingMobileCuttoff}) {
    margin-top: 25px;
  }
`)

export const QuizCardMobile = styled(QuizCard)(css`
  display: none;

  @media(max-width: ${marketingMobileCuttoff}) {
    display: flex;
  }
`)

export const QuizBigCardImage = styled('div')<EarnPointsImageProps>(props => css`
  filter: drop-shadow(0px 4px 12px rgba(23, 58, 104, 0.2));
  background-image: url(${props.imageUrl});
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  min-height: 228px;
  width: 100%;
  max-width: 440px;
  border-radius: 8px;
  display: flex;
  flex-direction: column-reverse;

  @media(max-width: ${marketingMobileCuttoff}) {
    min-height: 164px;
    max-width: 360px;
  }
  
`)

export const QuizSmallCardImage = styled('div')<EarnPointsImageProps>(props => css`
  filter: drop-shadow(0px 4px 12px rgba(23, 58, 104, 0.2));
  background-image: url(${props.imageUrl});
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  min-height: 88px;
  width: 100%;
  max-width: 206px;
  border-radius: 8px;
  display: flex;
  flex-direction: column-reverse;
  
`)

export const Badge = styled('div')<EarnPointsImageProps>(props => css`
  background-image: url(${props.imageUrl});
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
  margin-left: 58%;
  margin-bottom: 60px;
  height: 100%;

  @media(max-width: ${marketingMobileCuttoff}) {
    margin-left: 65%;
    margin-bottom: 18px;
    height: 86px;
  }
`)

export const EarnPointsSectionHeader = styled('div')(css`
  @media(max-width: ${marketingMobileCuttoff}) {
    margin-bottom: 20px;
    border-left: 10px solid ${lightBlue};
    padding-left: 15px;
  }
`)

export const EarnPointsTitle = styled.div`
  ${fontSize(32)};
  ${FontNormal(600)}
  color: ${black};
  margin-bottom: 5px;

  @media(max-width: ${marketingMobileCuttoff}) {
    ${fontSize(24)};
    margin-bottom: 0;
  }
`;

export const EarnPointsSubtitle = styled.div`
  ${fontSize(20)};
  ${FontNormal(400)}
  color: ${black};
  margin-bottom: 40px;

  @media(max-width: ${marketingMobileCuttoff}) {
    ${fontSize(16)};
    margin-left: 30px;
    margin-right: 30px;
    margin-bottom: 0;
  }
  
`;

export const EarnPointsBottomTitle = styled.div`
  ${fontSize(24)};
  ${FontNormal(600)}
  color: ${black};
  margin-bottom: 5px;
  margin-top: 40px;

  @media(max-width: ${marketingMobileCuttoff}) {
    ${fontSize(20)};
    margin-left: 30px;
    margin-right: 30px;
    text-align: center;
  }
`;

export const EarnPointsBottomSubtitle = styled.div`
  ${fontSize(24)};
  ${FontNormal(400)}
  color: ${black};

  @media(max-width: ${marketingMobileCuttoff}) {
    ${fontSize(16)};
    margin-left: 30px;
    margin-right: 30px;
    text-align: center;
  }
`;

export const EarnPointsSectionButtonWrapper = styled.div`
  margin-bottom: 50px;
  margin-top: 40px;

  @media(max-width: ${marketingMobileCuttoff}) {
    margin-top: 15px;
  }
`;

export const StyledButton = styled(Button)`
  width: 100%;
`;

export const SpinnerWrapper = styled.div`
  width: 100%;
  height: 70px;
  margin-bottom: 30px;
  margin-top: 30px;
`;

export const BigCardTitle = styled.div`
  ${fontSize(24)};
  ${FontNormal(600)}
  color: ${black};
  text-align: center;
  margin-bottom: 10px;

  @media(max-width: ${marketingMobileCuttoff}) {
    ${fontSize(16)};
    margin-bottom: 20px;
  }
`;

export const BigCardTitleItalic = styled(BigCardTitle)`
  font-style: italic;
`;

export const CardTitle = styled.div`
  ${fontSize(17)};
  ${FontNormal(600)}
  color: ${black};
  height: 100%;
  display: flex;
  align-items: center;
  margin-left: 5%;
  margin-right: 3%;
  @media(max-width: ${marketingMobileCuttoff}) {
    ${fontSize(16)};
  }
`;

export const SmallCardTitle = styled.div`
  ${fontSize(10)};
  ${FontNormal(600)}
  color: ${black};
  height: 100%;
  display: flex;
  align-items: center;
  margin-left: 5%;
  margin-right: 3%;
`;

export const ItalicCardTitle = styled.div`
  ${fontSize(15)};
  ${FontNormal(600)};
  font-style: italic;
  color: ${black};
  height: 100%;
  display: flex;
  align-items: center;
  margin-left: 5%;
  margin-right: 3%;
`;

export const Blur = styled.div`
  background-color: rgba(243, 245, 247, 0.5);
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  height: 60px;
`;

export const SmallBlur = styled.div`
  background-color: rgba(243, 245, 247, 0.5);
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  height: 30px;
`;

export const EmptyCol = styled.div`
  width: 8%;
`;

export const SmallEmptyCol = styled.div`
  width: 17%;
`;
